import '../styles/ContactForm.css'

const ContactForm = ({onCancel, onSubmit, initialData = {}}) => {
    return (
        <form className="add-contact-form" onSubmit={onSubmit}>
            <div className="contact-form-group">
                <label>שם מלא</label>
                <input name="full_name" required defaultValue={initialData.full_name || ''}/>
            </div>
            <div className="contact-form-group">
                <label>אימייל</label>
                <input name="email" type="email" defaultValue={initialData.email || ''}/>
            </div>
            <div className="contact-form-group">
                <label>טלפון</label>
                <input name="phone" type="tel" defaultValue={initialData.phone || ''}/>
            </div>
            <div className="form-buttons">
                <button type="submit" id="save" className="btn form-contact">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" stroke="#EF5DA8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                        <path d="M9 12l2 2l4 -4" />
                        <circle cx="12" cy="12" r="10" />
                    </svg>
                    שמור
                </button>
                <button type="button" id="cancel" className="btn form-contact" onClick={onCancel}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" stroke="#EF5DA8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                        <line x1="9" y1="9" x2="15" y2="15" />
                        <line x1="9" y1="15" x2="15" y2="9" />
                        <circle cx="12" cy="12" r="10" />
                    </svg>
                    ביטול
                </button>
            </div>
        </form>
    )
}

export default ContactForm;